module.exports = __webpack_public_path__ + "img/facebook.1506d9c0.svg";